import request, { service } from '@/utils/request'
import axios from 'axios'
import { userStore } from '@/stores/user'
import { getVisitorId } from '@/utils/utils'

/**
 * 获取联赛比赛列表（五大联赛和版权赛事）
 * @param {string} leagueId - 联赛ID
 * @returns {Promise} 比赛列表数据
 */
export function getLeagueMatchList(leagueId: string) {
  return request.post('/api/match/GetLeagueMatchList', {
    leagueId: leagueId
  })
}

/**
 * 联赛ID映射表
 */
export const LEAGUE_ID_MAP: Record<string, string> = {
  // 五大联赛
  'premier-league': '9',    // 英超
  'la-liga': '3',           // 西甲
  'serie-a': '15',          // 意甲
  'bundesliga': '21',       // 德甲
  'ligue-1': '20',          // 法甲
  
  // 版权赛事
  'j-league': '75',         // 日职联
  'a-league': '49',         // 澳超
  'j2-league': '179',       // 日职乙
  'k-league': '182'         // 韩K联
}

/**
 * 根据前端联赛ID获取API联赛ID
 * @param {string} frontendLeagueId - 前端使用的联赛ID
 * @returns {string} API需要的联赛ID
 */
export function getApiLeagueId(frontendLeagueId: string): string {
  return LEAGUE_ID_MAP[frontendLeagueId] || ''
}


export function getFootballMatchCategory() {
  return request.post('/api/match/FootballCat')
}

export function getBasketballMatchCategory() {
  return request.post('/api/match/BasketballCat')
}
export function getMatchFootballList(params: any) {
  return request.post('/api/match/List', params)
}

export function getMatchBasketballList(params: any) {
  return request.post('/api/match/BasketList', params)
}

// 获取足球详情
export function getMatchFootballDetailAPI(params: any) {
  return request.post('/api/match/Detail', params)
}

// 获取篮球详情
export function getMatchBasketballDetailAPI(params: any) {
  return request.post('/api/match/BasketDetail', params)
}

// 获取电竞详情
export function getEsportDetailAPI(params: any) {
  return request.post('/api/match/ESDetail', params)
}

// 获取足球数据

export function getMatchFootballDataAPI(params: any) {
  return request.post('/api/match/FootballSituations', params)
}

// 获取足球事件

export function getMatchFootballEventAPI(params: any) {
  return request.post('/api/match/FootballEvent', params)
}

// 足球比赛赛况技术统计

export function getFootballSituationsAPI(params: any) {
  return request.post('/api/match/FootballSituations', params)
}

// 获取足球指数

export function getMatchFootballOddsAPI(params: any) {
  return request.post('/api/match/FootballOdds', params)
}
// 文字直播

export function getMatchFootballTextDetail(params: any) {
  return request.post('/api/match/FootballLiveText', params)
}

// 技术统计
export function getMatchFootballStats(params: any) {
  return request.post('/api/match/FootballSituations', params)
}

// 篮球数据
export function getBasketballDetail(params: any) {
  return request.post('/api/match/BasketDetail', params)
}

// 篮球技术统计
export function getBasketballStats(params: any) {
  return request.post('/api/match/BasketStats', params)
}

// 篮球文字直播
export function getBasketballTextLive(params: any) {
  return request.post('/api/match/BasketLiveText', params)
}

// 网球列表
export function getTennisList(params: any) {
  return request.post('/api/match/TennisList', params)
}

export function getBaseballList(params: any) {
  return request.post('/api/match/BaseList', params)
}

// lol
export function getLOLList(params: any) {
  return request.post('/api/match/LOL', params)
}

// csgo
export function getCSGOLists(params: any) {
  return request.post('/api/match/CSGO', params)
}
// kog
export function getKogLists(params: any) {
  return request.post('/api/match/KOG', params)
}
// dota2
export function getDota2Lists(params: any) {
  return request.post('/api/match/DoTa2', params)
}
// 获取比赛信息
export function getMatchInfoAPI(params: any) {
  return axios.get('https://anime.zouwanlx.com/sc/gd.jsp', {
    params: {
      _t: new Date().getTime(),
      lan: 1,
      matchId: params.matchId
    }
  })
}
// 获取最新数据
export function getMatchLasterData(params: any) {
  return request.post('/api/match/ListScore', params)
}

export function getAllScheduleList(params: any) {
  return request.post('/api/match/AdminList', params)
}

// 足球比赛阵容
export function getFootballLineApi(params: any) {
  return request.post('/api/match/FootballLine', params)
}

// 足球比赛数据分析页积分排名
export function getFootballScoreRankApi(params: any) {
  return request.post('api/match/FootballScoreRank', params)
}

// 足球比赛数据分析页历史交锋
export function getFootballBattleHistoryApi(params: any) {
  return request.post('api/match/FootballBattleHistory', params)
}

// 足球比赛数据分析页队伍近况
export function getFootballRecentApi(params: any) {
  return request.post('api/match/FootballRecent', params)
}

// 足球比赛数据分析页赛果盘路统计
export function getFootballOddTrendApi(params: any) {
  return request.post('api/match/FootballOddTrend', params)
}

// 足球比赛数据分析页进球时间统计
export function getFootballGoalTimeApi(params: any) {
  return request.post('api/match/FootballGoalTime', params)
}

// 足球比赛数据分析页失球时间统计
export function getFootballLoseGoalTimeApi(params: any) {
  return request.post('api/match/FootballLoseGoalTime', params)
}

// 获取联赛积分排名（旧接口，保持兼容性）
export function getFootballIntegralRank(params: { leagueId?: string }) {
  return request.post('api/match/FootballIntegralRank', params)
}

// 获取联赛积分榜（新接口）
export function getLeagueRank(params: { leagueId: string }) {
  return request.post('/api/match/GetLeagueRank', params)
}

// 足球比赛数据分析页半全场赛果统计
export function getFootballHalfFullApi(params: any) {
  return request.post('api/match/FootballHalfFull', params)
}

// 足球比赛数据分析页进球总数统计
export function getFootballGoalSumApi(params: any) {
  return request.post('api/match/FootballGoalSum', params)
}

// 足球比赛数据分析页技术指标统计
export function getFootballTechStatApi(params: any) {
  return request.post('api/match/FootballTechStat', params)
}

// 足球比赛数据分析页双方未来赛程
export function getFootballFutureScheduleApi(params: any) {
  return request.post('api/match/FootballFutureSchedule', params)
}

// 篮球指数接口（直播详情页使用）
export function getMatchBasketballOddsAPI(params: any) {
  return request.post('/api/match/BasketOdds', params)
}

// 篮球相同指数统计（赛事详情页使用）
export function getBasketballOddsLive(params: any) {
  return request.post('/api/match/BasketOdds', params)
}
// 篮球球员统计
export function getBasketballPlayerCount(params: any) {
  return request.post('/api/match/BasketPlayerCount', params)
}

// 篮球阵容
export function getBasketballLineApi(params: any) {
  return request.post('/api/match/BasketLine', params)
}

export function getBasketballBattleHistory(params: any) {
  return request.post('/api/match/BasketBattleHistory', params)
}

export function getBasketballScoreRank(params: any) {
  return request.post('/api/match/BasketScoreRank', params)
}

export function getBasketballRecentHistory(params: any) {
  return request.post('/api/match/BasketRecent', params)
}

export function getBasketballOddTrend(params: any) {
  return request.post('/api/match/BasketOddTrend', params)
}

// 电竞赛况
export function getEsBattleCount(params: any) {
  return request.post('/api/match/EsBattleCount', params)
}

// 电竞赛况
export function getEsStatusAPI(params: any) {
  return request.post('/api/match/EsStatus', params)
}

// 电竞被ban接口
export function getEsBanPick(params: any) {
  return request.post('/api/match/BanPick', params)
}
// 电竞阵容
export function getTeamPlayer(params: any) {
  return request.post('/api/match/TeamPlayer', params)
}
// 参战选手
export function getESPlayerInfo(params: any) {
  return request.post('/api/match/ESPlayerInfo', params)
}

// 电竞指数
export function getESOdds(params: any) {
  return request.post('/api/match/EsOdd', params)
}

// 电竞历史交锋
export function getESHistory(params: any) {
  return request.post('/api/match/EsHistory', params)
}

// 电竞CSGO赛况
export function getCSGOStats(params: any) {
  return request.post('/api/match/CSGOStats', params)
}

// 电竞CSGO参赛选手
export function getCSGOPlayer(params: any) {
  return request.post('/api/match/CSGOPlayer', params)
}

// 电竞ESGO历史
export function getCSGOHistory(params: any) {
  return request.post('/api/match/CSGOHistory', params)
}

//网球详情
export function getTennisDetail(params: any) {
  return request.post('/api/match/TennisDetail', params)
}

//棒球详情
export function getBaseballDetail(params: any) {
  return request.post('/api/match/BaseDetail', params)
}

/**
 * AI实时分析接口（SSE流式数据）
 * @param {number} matchId - 比赛ID
 * @param {number} matchType - 运动类型：1=足球，2=篮球
 * @returns {Promise<Response>} Fetch Response 对象，用于 SSE 读取
 */
export async function getAIAnalysis(matchId: number, matchType: number): Promise<Response> {
  // 获取当前使用的 baseURL
  const baseURL = service.defaults.baseURL || ''

  // 获取用户 token
  const store = userStore()
  const token = store.getToken()

  // 获取设备 ID
  const deviceId = await getVisitorId()

  // 构建完整的 URL
  const url = `${baseURL}/api/match/StreamBuyRealAnalysis`

  const requestBody = {
    match_id: matchId,
    match_type: matchType
  }

  console.log('🔧 AI分析接口配置:', {
    url,
    token: token ? `${token.substring(0, 10)}...` : '无',
    deviceId: deviceId ? `${deviceId.substring(0, 10)}...` : '无',
    body: requestBody
  })

  // 发起 Fetch 请求（使用 Fetch API 而非 Axios，因为需要处理 SSE 流）
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
      'Connection': 'keep-alive',
      'Cache-Control': 'no-cache',
      'Token': token,  // 注意：接口文档要求是大写的 Token
      'DeviceId': deviceId
    },
    body: JSON.stringify(requestBody)
  })

  console.log('📬 接口响应状态:', response.status, response.statusText)

  return response
}

/**
 * 获取购买的AI分析历史列表（指定比赛的历史记录）
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页码，从1开始
 * @param {number} params.size - 每页数据量
 * @param {number} params.match_id - 比赛ID
 * @returns {Promise} 历史分析列表数据
 */
export const getBuyRealAnalysisList = (params: { page: number; size: number; match_id: number }) => {
  return request.post('/api/match/GetBuyRealAnalysisList', params)
}

/**
 * 获取足球国家地区信息（用于赛事筛选）
 * @returns {Promise} 国家地区数据，包含continent、country、countryLetter分组
 */
export function getFootballCountryRate() {
  return request.get('/api/match/FootballCountry')
}











